var DappErrorName = /* @__PURE__ */ ((DappErrorName2) => {
  DappErrorName2["DecodeError"] = "Decode Error";
  DappErrorName2["InvalidParams"] = "Invalid Params";
  DappErrorName2["UserRejected"] = "User Rejected";
  DappErrorName2["NotAllowed"] = "Not Allowed";
  return DappErrorName2;
})(DappErrorName || {});
class DappError extends Error {
  constructor(message, name = "Invalid Params", rawError = void 0) {
    super(message);
    if (message === "User Rejected") {
      this.name = message;
    } else {
      this.name = name;
    }
    this.rawError = rawError;
  }
}
function encode(obj, pfx) {
  let k;
  let i;
  let tmp;
  let str = "";
  for (k in obj) {
    if ((tmp = obj[k]) !== void 0) {
      if (Array.isArray(tmp)) {
        for (i = 0; i < tmp.length; i++) {
          str && (str += "&");
          str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp[i])}`;
        }
      } else {
        str && (str += "&");
        str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp)}`;
      }
    }
  }
  return (pfx || "") + str;
}
function toValue(mix) {
  if (!mix)
    return "";
  const str = decodeURIComponent(mix);
  if (str === "false")
    return false;
  if (str === "true")
    return true;
  return +str * 0 === 0 && `${+str}` === str ? +str : str;
}
function decode(str) {
  let tmp;
  let k;
  const out = {};
  const arr = str.split("&");
  while (tmp = arr.shift()) {
    tmp = tmp.split("=");
    k = tmp.shift();
    if (out[k] !== void 0) {
      out[k] = [].concat(out[k], toValue(tmp.shift()));
    } else {
      out[k] = toValue(tmp.shift());
    }
  }
  return out;
}
function parseSearchWith(parser) {
  return (searchStr) => {
    if (searchStr.substring(0, 1) === "?") {
      searchStr = searchStr.substring(1);
    }
    const query = decode(searchStr);
    for (const key in query) {
      const value = query[key];
      if (typeof value === "string") {
        try {
          query[key] = parser(value);
        } catch (err) {
        }
      }
    }
    if (Object.keys(query).length === 0) {
      throw new DappError("Invalid request", DappErrorName.InvalidParams);
    }
    return query;
  };
}
function stringifySearchWith(stringify, parser) {
  function stringifyValue(val) {
    if (typeof val === "object" && val !== null) {
      try {
        return stringify(val);
      } catch (err) {
      }
    } else if (typeof val === "string" && typeof parser === "function") {
      try {
        parser(val);
        return stringify(val);
      } catch (err) {
      }
    }
    return val;
  }
  return (search) => {
    search = { ...search };
    if (search) {
      Object.keys(search).forEach((key) => {
        const val = search[key];
        if (typeof val === "undefined" || val === void 0) {
          delete search[key];
        } else if (Array.isArray(val)) {
          search[key] = val.map(stringifyValue);
        } else {
          search[key] = stringifyValue(val);
        }
      });
    }
    const searchStr = encode(search).toString();
    return searchStr ? `?${searchStr}` : "";
  };
}
const decodeSearch = parseSearchWith(JSON.parse);
const encodeSearch = stringifySearchWith(JSON.stringify, JSON.parse);
function bufferToHex(buffer) {
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
function isStandaloneBrowser() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
}
var DappRequestType = /* @__PURE__ */ ((DappRequestType2) => {
  DappRequestType2["Auth"] = "Auth";
  DappRequestType2["SignMessage"] = "SignMessage";
  DappRequestType2["SignEvm"] = "SignEvm";
  DappRequestType2["SignCkbTx"] = "SignCkbTx";
  DappRequestType2["SignCotaNFT"] = "SignCotaNFT";
  DappRequestType2["SignNostrEvent"] = "SignNostrEvent";
  DappRequestType2["EncryptNostrMessage"] = "EncryptNostrMessage";
  DappRequestType2["DecryptNostrMessage"] = "DecryptNostrMessage";
  return DappRequestType2;
})(DappRequestType || {});
var DappCommunicationType = /* @__PURE__ */ ((DappCommunicationType2) => {
  DappCommunicationType2["Popup"] = "popup";
  DappCommunicationType2["Redirect"] = "redirect";
  return DappCommunicationType2;
})(DappCommunicationType || {});
class RedirectErrorWithState extends Error {
  constructor(message, state) {
    super(message);
    this.message = message;
    this.state = state;
    this.state = state;
  }
}
const getRedirectResponse = (uri) => {
  const url = new URL(uri || window.location.href);
  const data = url.searchParams.get("_data_");
  if (!data) {
    throw new Error("No data found");
  }
  const res = decodeSearch(data);
  if (res.error != null) {
    throw new RedirectErrorWithState(res.error, res.state);
  }
  return res.data;
};
const internalConfig = {
  joyidAppURL: "https://testnet.joyid.dev"
};
const getConfig$1 = () => internalConfig;
const JOYID_REDIRECT = "joyid-redirect";
const buildJoyIDURL = (request, type, path) => {
  const joyidURL = request.joyidAppURL ?? getConfig$1().joyidAppURL;
  const url = new URL(`${joyidURL}`);
  url.pathname = path;
  let redirectTo = request.redirectURL;
  if (type === "redirect") {
    const redirectURL = new URL(redirectTo);
    redirectURL.searchParams.set(JOYID_REDIRECT, "true");
    redirectTo = redirectURL.href;
  }
  url.searchParams.set("type", type);
  const data = encodeSearch({
    ...request,
    redirectURL: redirectTo
  });
  url.searchParams.set("_data_", data);
  return url.href;
};
class GenericError extends Error {
  constructor(error, error_description) {
    super(error_description);
    this.error = error;
    this.error_description = error_description;
    Object.setPrototypeOf(this, GenericError.prototype);
  }
  static fromPayload({
    error,
    error_description
  }) {
    return new GenericError(error, error_description);
  }
}
class TimeoutError extends GenericError {
  constructor() {
    super("timeout", "Timeout");
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}
class PopupTimeoutError extends TimeoutError {
  constructor(popup) {
    super();
    this.popup = popup;
    Object.setPrototypeOf(this, PopupTimeoutError.prototype);
  }
}
class PopupCancelledError extends GenericError {
  constructor(popup) {
    super("cancelled", "Popup closed");
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
class PopupNotSupportedError extends GenericError {
  constructor(popup) {
    super(
      "NotSupported",
      "Popup window is blocked by browser. see: https://docs.joy.id/guide/best-practice#popup-window-blocked"
    );
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
const DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS = 3e3;
const openPopup$1 = (url = "") => {
  const width = 400;
  const height = 600;
  const left = window.screenX + (window.innerWidth - width) / 2;
  const top = window.screenY + (window.innerHeight - height) / 2;
  return window.open(
    url,
    "joyid:authorize:popup",
    `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`
  );
};
const runPopup = (config) => new Promise((resolve, reject) => {
  if (isStandaloneBrowser()) {
    reject(new PopupNotSupportedError(config.popup));
  }
  let popupEventListener;
  let timeoutId;
  const popupTimer = setInterval(() => {
    if (config.popup && config.popup.closed) {
      clearInterval(popupTimer);
      clearTimeout(timeoutId);
      window.removeEventListener("message", popupEventListener, false);
      reject(new PopupCancelledError(config.popup));
    }
  }, 1e3);
  timeoutId = setTimeout(
    () => {
      clearInterval(popupTimer);
      reject(new PopupTimeoutError(config.popup));
      window.removeEventListener("message", popupEventListener, false);
    },
    (config.timeoutInSeconds || DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS) * 1e3
  );
  popupEventListener = (e) => {
    var _a;
    const appURL = new URL(getConfig$1().joyidAppURL);
    if (e.origin !== appURL.origin) {
      return;
    }
    if (!e.data || ((_a = e.data) == null ? void 0 : _a.type) !== config.type) {
      return;
    }
    clearTimeout(timeoutId);
    clearInterval(popupTimer);
    window.removeEventListener("message", popupEventListener, false);
    config.popup.close();
    if (e.data.error) {
      reject(new Error(e.data.error));
    }
    resolve(e.data.data);
  };
  window.addEventListener("message", popupEventListener);
});
const styleId = "joyid-block-dialog-style";
const approveId = "joyid-block-dialog-approve";
const rejectId = "joyid-block-dialog-reject";
const styleSheet = `
.joyid-block-dialog {
  position: fixed;
  top: 32px;
  left: 50%;
  width: 340px;
  margin-left: -170px;
  background: white;
  color: #333;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 110px;
  z-index: 100002;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  border-radius: 8px;
  padding: 16px 20px;
}
.joyid-block-dialog-bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  z-index: 100001;
  display: block;
}
.joyid-block-dialog-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
}
.joyid-block-dialog-tip {
  font-size: 12px;
  color: #777;
}
.joyid-block-dialog-btn {
  width: 90px;
  height: 35px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
}
.joyid-block-dialog-action {
  text-align: right;
}
#${approveId} {
  border: 1px solid #333;
  color: #333;
  background: #D2FF00;
  margin-bottom: 8px;
}

#${rejectId} {
  background: transparent;
}
`;
const dialogInnerHtml = `
<div class="joyid-block-dialog">
  <div class="joyid-block-dialog-content">
    <div class="joyid-block-dialog-title">
      Request Pop-up
    </div>
    <div class="joyid-block-dialog-tip">
      Click Approve to complete creating or using wallet
    </div>
  </div>
  <div class="joyid-block-dialog-action">
    <button class="joyid-block-dialog-btn" id="${approveId}">Approve</button>
    <button class="joyid-block-dialog-btn" id="${rejectId}">Reject</button>
  </div>
</div>
`;
const appendStyle = () => {
  const _style = document.getElementById(styleId);
  if (_style) {
    return;
  }
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(styleSheet));
  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(style);
};
const createBlockDialog = (cb) => {
  appendStyle();
  const dialog = document.createElement("div");
  dialog.innerHTML = dialogInnerHtml;
  document.body.appendChild(dialog);
  const dialogBg = document.createElement("div");
  dialogBg.className = "joyid-block-dialog-bg";
  document.body.appendChild(dialogBg);
  const approveBtn = document.getElementById(approveId);
  const rejectBtn = document.getElementById(rejectId);
  const closeDialog = () => {
    document.body.removeChild(dialog);
    document.body.removeChild(dialogBg);
  };
  return new Promise((resolve, reject) => {
    approveBtn == null ? void 0 : approveBtn.addEventListener("click", async () => {
      try {
        const data = await cb();
        closeDialog();
        resolve(data);
      } catch (error) {
        closeDialog();
        reject(error);
      }
    });
    rejectBtn == null ? void 0 : rejectBtn.addEventListener("click", () => {
      closeDialog();
      reject(new Error("User Rejected"));
    });
  });
};
const buildJoyIDSignMessageURL = (request, type) => buildJoyIDURL(request, type, "/sign-message");
const signMessageWithRedirect$1 = (request) => {
  window.location.assign(buildJoyIDSignMessageURL(request, "redirect"));
};
const signMessageWithPopup = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup$1("");
    if (!config.popup) {
      return createBlockDialog(() => signMessageWithPopup(request, config));
    }
  }
  config.popup.location.href = buildJoyIDSignMessageURL(request, "popup");
  return runPopup({
    ...config,
    type: DappRequestType.SignMessage
  });
};
const signMessageCallback$1 = (uri) => getRedirectResponse(uri);
const buildJoyIDAuthURL = (request, type) => buildJoyIDURL(request, type, "/auth");
const authWithRedirect = (request) => {
  window.location.assign(buildJoyIDAuthURL(request, "redirect"));
};
const authWithPopup = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup$1("");
    if (!config.popup) {
      return createBlockDialog(() => authWithPopup(request, config));
    }
  }
  config.popup.location.href = buildJoyIDAuthURL(
    request,
    DappCommunicationType.Popup
  );
  return runPopup({
    ...config,
    type: DappRequestType.Auth
  });
};
const authCallback = (uri) => getRedirectResponse(uri);
const openPopup = openPopup$1;
const JOYID_STORAGE_KEY = "joyid:ethereum::address";
const safeExec = (fn) => {
  try {
    return fn();
  } catch (error) {
    return null;
  }
};
const buildSignTxURL = (config, type = "popup") => buildJoyIDURL(
  {
    ...internalConfig,
    ...config
  },
  type,
  "/sign-evm"
);
const buildSignTypedDataUrl = (config, type = "popup") => buildJoyIDURL(
  {
    ...internalConfig,
    ...config
  },
  type,
  "/sign-typed-data"
);
const buildConnectUrl = (config) => buildJoyIDAuthURL(
  {
    ...internalConfig,
    ...config,
    requestNetwork: "ethereum"
  },
  "redirect"
);
const buildSignMessageUrl = (message, config, type = "popup") => {
  const isData = typeof message !== "string";
  return buildJoyIDSignMessageURL(
    {
      ...config,
      ...internalConfig,
      requestNetwork: "ethereum",
      challenge: typeof message !== "string" ? bufferToHex(message) : message,
      isData
    },
    type
  );
};
const initConfig = (config) => {
  Object.assign(internalConfig, config);
  return internalConfig;
};
const getConfig = () => internalConfig;
const connect = async (config) => {
  config = {
    ...internalConfig,
    ...config
  };
  const res = await authWithPopup({
    redirectURL: location.href,
    requestNetwork: "ethereum",
    ...config
  });
  safeExec(() => {
    localStorage.setItem(JOYID_STORAGE_KEY, res.ethAddress);
  });
  return res.ethAddress;
};
const disconnect = () => {
  safeExec(() => {
    localStorage.removeItem(JOYID_STORAGE_KEY);
  });
};
const getConnectedAddress = () => safeExec(() => localStorage.getItem(JOYID_STORAGE_KEY)) || null;
const ensureSignerAddress = (signerAddress) => {
  let address = signerAddress;
  if (!address) {
    const connected = getConnectedAddress();
    if (connected) {
      address = connected;
    }
  }
  if (!address) {
    throw new Error("signerAddress is required");
  }
  return address;
};
const connectWithRedirect = (redirectURL, config) => {
  config = {
    ...internalConfig,
    ...config
  };
  authWithRedirect({
    redirectURL,
    requestNetwork: "ethereum",
    ...config
  });
};
const connectCallback = (uri) => {
  const { state, ethAddress: address } = authCallback(uri);
  safeExec(() => {
    localStorage.setItem(JOYID_STORAGE_KEY, address);
  });
  if (state) {
    return {
      state,
      address
    };
  }
  return {
    address
  };
};
const signMessage = async (message, signerAddress, config) => {
  const isData = typeof message !== "string";
  config = {
    ...internalConfig,
    ...config
  };
  signerAddress = ensureSignerAddress(signerAddress);
  const res = await signMessageWithPopup({
    requestNetwork: "ethereum",
    challenge: typeof message !== "string" ? bufferToHex(message) : message,
    isData,
    address: signerAddress,
    redirectURL: location.href,
    ...config
  });
  return res.signature;
};
const signMessageWithRedirect = (redirectURL, message, signerAddress, config) => {
  const isData = typeof message !== "string";
  config = {
    ...internalConfig,
    ...config
  };
  signerAddress = ensureSignerAddress(signerAddress);
  signMessageWithRedirect$1({
    requestNetwork: "ethereum",
    challenge: typeof message !== "string" ? bufferToHex(message) : message,
    isData,
    address: signerAddress,
    redirectURL,
    ...config
  });
};
const signMessageCallback = (uri) => {
  const { signature, state } = signMessageCallback$1(uri);
  if (state) {
    return {
      state,
      signature
    };
  }
  return {
    signature
  };
};
const signTypedData = async (typedData, signerAddress, config) => {
  config = {
    ...internalConfig,
    ...config
  };
  signerAddress = ensureSignerAddress(signerAddress);
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      return createBlockDialog(
        () => signTypedData(typedData, signerAddress, config)
      );
    }
  }
  const { popup, timeoutInSeconds, ...dappConfig } = config;
  config.popup.location.href = buildSignTypedDataUrl({
    ...dappConfig,
    typedData,
    signerAddress,
    redirectURL: location.href
  });
  const res = await runPopup({
    timeoutInSeconds: timeoutInSeconds || 5e3,
    popup,
    type: DappRequestType.SignMessage
  });
  return res.signature;
};
const signTypedDataWithRedirect = (redirectURL, typedData, signerAddress, config) => {
  config = {
    ...internalConfig,
    ...config
  };
  const url = buildSignTypedDataUrl(
    {
      ...config,
      typedData,
      signerAddress,
      redirectURL
    },
    "redirect"
  );
  window.location.assign(url);
};
const signTypedDataCallback = signMessageCallback;
const signTxWithPopupBase = async (tx, signerAddress, config, isSend) => {
  const signer = signerAddress || tx.from || getConnectedAddress();
  if (!signer) {
    throw new Error("signerAddress or tx.from is required");
  }
  config = {
    ...internalConfig,
    ...config
  };
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      return createBlockDialog(
        () => signTxWithPopupBase(tx, signer, config, isSend)
      );
    }
  }
  const { popup, timeoutInSeconds, ...dappConfig } = config;
  config.popup.location.href = buildSignTxURL({
    ...dappConfig,
    tx,
    signerAddress: signer,
    redirectURL: location.href,
    isSend
  });
  const res = await runPopup({
    timeoutInSeconds: timeoutInSeconds || 5e3,
    popup,
    type: DappRequestType.SignEvm
  });
  return res.tx;
};
const signTransaction = async (tx, signerAddress, config) => signTxWithPopupBase(tx, signerAddress, config, false);
const sendTransaction = async (tx, signerAddress, config) => signTxWithPopupBase(tx, signerAddress, config, true);
const signTransactionRedirectBase = (redirectURL, tx, signerAddress, config, isSend) => {
  const signer = signerAddress || tx.from || getConnectedAddress();
  if (!signer) {
    throw new Error("signerAddress or tx.from is required");
  }
  config = {
    ...internalConfig,
    ...config
  };
  const url = buildSignTxURL(
    {
      ...config,
      tx,
      signerAddress: signer,
      redirectURL,
      isSend
    },
    "redirect"
  );
  window.location.assign(url);
};
const signTransactionWithRedirect = (redirectURL, tx, signerAddress, config) => signTransactionRedirectBase(redirectURL, tx, signerAddress, config, false);
const sendTransactionWithRedirect = (redirectURL, tx, signerAddress, config) => signTransactionRedirectBase(redirectURL, tx, signerAddress, config, true);
const signTransactionCallback = (uri) => {
  const { tx, state } = getRedirectResponse(uri);
  if (state) {
    return {
      state,
      tx
    };
  }
  return {
    tx
  };
};
const sendTransactionCallback = signTransactionCallback;
export {
  buildConnectUrl,
  buildSignMessageUrl,
  buildSignTxURL,
  buildSignTypedDataUrl,
  connect,
  connectCallback,
  connectWithRedirect,
  disconnect,
  getConfig,
  getConnectedAddress,
  initConfig,
  openPopup,
  sendTransaction,
  sendTransactionCallback,
  sendTransactionWithRedirect,
  signMessage,
  signMessageCallback,
  signMessageWithRedirect,
  signTransaction,
  signTransactionCallback,
  signTransactionRedirectBase,
  signTransactionWithRedirect,
  signTypedData,
  signTypedDataCallback,
  signTypedDataWithRedirect
};
